// ANCHOR Model
import createModel, { createSelector } from 'react-scoped-model';

// ANCHOR SWR
import useSWR from 'swr';

// ANCHOR API
import { getCourseModules } from '@lyon/utils/api/course-module';

interface IProps {
  courseId: string;
}

export const CourseModulesData = createModel(({ courseId }: IProps) => {
  const response = useSWR(
    `/courses/${courseId}/modules`,
    () => getCourseModules({ courseId }),
  );

  return {
    ...response,
  };
}, {
  displayName: 'Models.CourseModulesData',
});

export const useCourseModulesDataUpdate = createSelector(
  CourseModulesData,
  (state) => state.mutate,
);

export const useCourseModulesData = createSelector(
  CourseModulesData,
  ({ data }) => data,
);

export const useCourseModulesDataTotalItems = createSelector(
  CourseModulesData,
  ({ data }) => data?.reduce((total, item) => total + item.moduleItems.length, 0),
);
